import axios from 'axios'
import { AuthModel, ConnectAndHealModel, FlashAidModel, HrModel, MidTermAdditionRequest, PristynCareModel, ResetPasswordModel, UserModel } from './_models'
import {
  Capacitor,
} from '@capacitor/core';

const API_URL = process.env.REACT_APP_FUTURISK_LIVE_URL;
//'http://localhost:55991' //process.env.REACT_APP_FUTURISK_LIVE_URL   REACT_APP_FUTURISK_TEST_URL
//REACT_APP_FUTURISK_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const REQUEST_PASSWORD_URL = `${API_URL}/SSO/AccountForgotPassword`
//export const SSO_LOGIN_URL = 'https://sso.futurisk.in/api/login/UserDetails'
export const SSO_LOGIN_URL = `${API_URL}/api/login/UserDetails`
export const SSO_HR_URL = `${API_URL}/api/login/HrDetails`
export const pristyncare_URL = `${API_URL}/api/PristynCare`
export const ConnectAndHeal_URL = `https://etl.futurisk.in/webhook/e97c331f-bfa9-4c74-911f-f74c3f0117d8`
export const FlashAid_URL = `${API_URL}/api/FlashAid`
export const ResetPassword = `${API_URL}/SSO/ResetPassword/ResetDefaultPassword`
export const MidtermUrl = `${API_URL}/SSO/Api/MidTermAddition`

// Server should return AuthModel
/**
 * 
 * axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  }
 */

  export function MidTermAddition(request: MidTermAdditionRequest) {
    return axios.post<MidTermAdditionRequest>(MidtermUrl, request,{headers: { "Content-Type": "application/json" }});
  }

  export function ResetDefaultPassword(loginid: string, password : string) {
    var bodyFormData = new FormData();
    bodyFormData.append('loginid', loginid)
    bodyFormData.append('newpassword', password)

    return axios.post<ResetPasswordModel>(ResetPassword, bodyFormData,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    )
    
  }

  export function ConnectAndHealSignup(request: ConnectAndHealModel) {
    return axios.post<{ result: boolean }>(ConnectAndHeal_URL, request)
  }

  export function flashaid(data: FlashAidModel) {
    var bodyFormData = new FormData();
    bodyFormData.append('Mobile', data.Mobile)
    bodyFormData.append('FirstName', data.FirstName)
    bodyFormData.append('source', 'futurisk')
    bodyFormData.append('disease', data.disease)
    bodyFormData.append('City', data.City)
    bodyFormData.append('CrmLoginId', data.CrmLoginId)
    return axios.post<FlashAidModel>(FlashAid_URL, bodyFormData,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    )
    
  }

export function pristyncare(data: PristynCareModel) {
  var bodyFormData = new FormData();
  bodyFormData.append('Mobile', data.Mobile)
  bodyFormData.append('FirstName', data.FirstName)
  bodyFormData.append('source', 'futurisk')
  bodyFormData.append('disease', data.disease)
  bodyFormData.append('City', data.City)
  bodyFormData.append('CrmLoginId', data.CrmLoginId)
  return axios.post<PristynCareModel>(pristyncare_URL, bodyFormData,
    {
      headers: { "Content-Type": "multipart/form-data" }
    }
  )
  
}
export function login(email: string, password: string,page: string): AuthModel {
  return ({
    'username': email,
    'password': password,
    'page':page,
  })
}




// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(request: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    'LoginID' : request,
  })
}

export function getUserByToken(token: AuthModel) {

  var bodyFormData = new FormData();
  bodyFormData.append('username', token.username)
  bodyFormData.append('password', token.password)
  bodyFormData.append('source', Capacitor.getPlatform())
  bodyFormData.append('page', token.page)
  return axios.post<UserModel>(SSO_LOGIN_URL, bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}

export function getUserByTokenSso(token: AuthModel) {

  var bodyFormData = new FormData();
  bodyFormData.append('username', token.username)
  bodyFormData.append('password', token.password)
  bodyFormData.append('source', 'SSO')
  bodyFormData.append('page', token.page)
  return axios.post<UserModel>(SSO_LOGIN_URL, bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}

export function getHrOptions(token: AuthModel) {

  var bodyFormData = new FormData();
  bodyFormData.append('username', token.username)
  bodyFormData.append('password', token.password)
  return axios.post<HrModel>(SSO_HR_URL, bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}

